<div class="exception-body pagenotfound-body" *appTranslate="let t">
  <div class="exception-logo">
    <a class="logo" [routerLink]="['/app']">
      <img class="logo-img" src="assets/layout/images/logo.png" />
      <img class="logo-txt" src="assets/layout/images/logo-text.svg" />
    </a>
  </div>

  <div class="exception-panel">
    <img src="assets/layout/images/exception/icon-404.png" />

    <app-button [label]="t('home.title')" [routerLink]="['/']"></app-button>
  </div>

  <div class="exception-band">
    <div class="exception-content">
      <h3>{{ t("notFound.title") }}</h3>
      <p>{{ t("notFound.message") }}</p>
    </div>
  </div>
</div>
